



















import { defineComponent } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import BaseInputSearch from "@/components/BaseInputSearch";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";
import SearchUserList from "./SearchUserList.vue";
import { FollowerMappedType } from "../type";

export default defineComponent({
  name: "SearchUserView",
  components: { BasePage, PageTitle, SearchUserList, BaseInputSearch },
  props: {
    screenNameValue: { type: String, default: "" },
    loading: { type: Boolean },
    users: { type: Array as () => UserPublicData[], default: [] },
    mappedFollowings: { type: Object as () => FollowerMappedType, default: {} },
    followingInProcessUsers: { type: Array as () => string[], default: [] },
  },
  computed: {
    hasAppendIcon(): boolean {
      return this.screenNameValue.length > 0;
    },
  },
  methods: {
    follow(user: UserPublicData) {
      this.$emit("follow", user);
    },
  },
});
